import React from "react";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

const AddCardLinkButton = ({ onClick, laneType }) => {
  const { t } = useTranslation();

  // Determine label based on lane/content type
  const getLabel = () => {
    switch (laneType) {
      case "COMPANY":
        return t("New Account");
      case "CONTACT":
        return t("New Contact");
      case "SALE":
        return t("New Deal");
      default:
        return t("Add item");
    }
  };

  return (
    <div
      onClick={onClick}
      className="flex items-center justify-center gap-1.5 mx-1.5 mt-2 py-2 px-3 rounded-lg border border-dashed border-gray-300 text-sm text-gray-500 cursor-pointer hover:border-blue-400 hover:text-blue-600 hover:bg-blue-50/50 transition-colors"
    >
      <Plus className="w-4 h-4" />
      <span>{getLabel()}</span>
    </div>
  );
};

export default AddCardLinkButton;
